<template>
  <div class="pointer__wrapper">
    <div class="pointer__wrapper pointer__wrapper--small">
      <div
        class="pointer apollo"
        ref="pointer"
        :style="{
          width: `${circle.cx}px`,
          height: `${circle.cy}px`,
          top: `${circle.top}px`,
          left: `${circle.left}px`,
        }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          :viewBox="`0 0 ${circle.cx * 2} ${circle.cy * 2}`"
        >
          <circle
            :r="circle.r"
            :cx="circle.cx"
            :cy="circle.cy"
            ref="circle"
          />
        </svg>
      </div>
    </div>

    <div class="pointer__wrapper pointer__wrapper--big">
      <div
        class="pointer__image__wrapper"
        :style="{ transform : `translate3d(${coordsImage.x}px, ${coordsImage.y}px, 0px)`}"
      >
        <div class="pointer__image" style="opacity: 0;">
          <div class="pointer__image__picture" />
        </div>
      </div>

      <div
        class="pointer--big"
        ref="pointerBig"
        :style="{ transform : `translate3d(${coords.x}px, ${coords.y}px, 0px) scale(${scale})`}"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { TweenMax, Expo } from 'gsap/TweenMax';

import apollo from '@/scripts/apollo';

export default {
  name: 'Pointer',

  data() {
    return {
      anim: false,
      scale: 1,

      coords: {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2,
      },

      coordsImage: {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2,
      },

      circle: {
        r: 15,
        cx: 16,
        cy: 16,
        top: 0,
        left: 0,
      }
    };
  },

  computed: {
    ...mapGetters({
      init: 'getInit',
    }),
  },

  watch: {
    init(n) {
      if (n) {
        TweenMax.to(this.$refs.circle, 1.5, {
          strokeDashoffset: 0,
          ease: Expo.easeOut,

          onComplete: () => {
            document.body.classList.remove('wait');

            TweenMax.set(document.body, {
              clearProps: 'all',
            });

            TweenMax.to(this, 2.5, {
              scale: 1,
              ease: Expo.easeOut,
            });

            TweenMax.to(this.circle, 1, {
              r: 15,
              cx: 16,
              cy: 16,
              top: 0,
              left: 0,
              ease: Expo.easeOut,
            });

            TweenMax.set(this.$refs.pointerBig.parentNode, {
              zIndex: -1,
            });

            TweenMax.set(this.$refs.circle, {
              strokeDasharray: 0,
              strokeDashoffset: 0,
            });
            this.anim = true;
          },
        });
      }
    },
  },

  mounted() {
    this.scale = (window.innerHeight < window.innerWidth ? window.innerWidth / 400 : window.innerHeight / 400) * 1.2;

    apollo.init();

    window.addEventListener('apollo-update', this.currentPosition);
    window.addEventListener('apollo-enter', this.hoverEnter);
    window.addEventListener('apollo-leave', this.hoverLeave);

    TweenMax.set(this.circle, {
      r: 127,
      cx: 128,
      cy: 128,
      top: -56,
      left: -56,
    });

    TweenMax.set(document.body, {
      backgroundColor: '#FFFFFF',
    });

    TweenMax.set(this.$refs.circle, {
      strokeDasharray: 797.6422119140625,
      strokeDashoffset: 797.6422119140625,
    });
  },

  methods: {
    currentPosition(event) {
      if (!this.init) return;
      TweenMax.killTweensOf(this.coords);
      TweenMax.to(this.coords, 1.5, {
        x: event.detail.x,
        y: event.detail.y,
        ease: Expo.easeOut,
      });

      TweenMax.killTweensOf(this.coordsImage);
      TweenMax.to(this.coordsImage, 0.5, {
        x: event.detail.x,
        y: event.detail.y,
        ease: Expo.easeOut,
      });
    },

    hoverEnter(event) {
      if (!this.anim) return;
      const scale = event.detail.domElement.classList.contains('interactive-span') ? 1.5 : 0.75;

      TweenMax.killTweensOf(this);
      TweenMax.to(this, 1.25, {
        scale,
        ease: Expo.easeOut,
      });

      TweenMax.set(this.$refs.circle, {
        strokeDasharray: 0,
        strokeDashoffset: 0,
      });

      TweenMax.killTweensOf(this.circle);
      TweenMax.to(this.circle, 1.25, {
        r: 127,
        cx: 128,
        cy: 128,
        top: -56,
        left: -56,
        ease: Expo.easeOut,
      });

    },

    hoverLeave() {
      if (!this.anim) return;
      TweenMax.killTweensOf(this);
      TweenMax.to(this, 1, {
        scale: 1,
        ease: Expo.easeOut,
      });

      TweenMax.killTweensOf(this.circle);
      TweenMax.to(this.circle, 1.25, {
        r: 15,
        cx: 16,
        cy: 16,
        top: 0,
        left: 0,
        ease: Expo.easeOut,
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.pointer {
  position: absolute;
  font-size: 0;
  z-index: 4;

  // width: 32px;
  // height: 32px;

  svg {
    fill: none;
    stroke: rgba($color-dark, 0.4);

    @supports not(-moz-appearance:none ){
      stroke: rgba($color-dark, 0.4);
    }

    stroke-width: 1px;
    transition: stroke 0.5s ease-out;

    @include mq($and: $is-touch-device) {
      display: none;
    }

    overflow: visible !important;
    backface-visibility: hidden;
  }

  &.apollo__cursor--active {
    svg {
      stroke: rgba($color-dark, 0.6);
      stroke-width: 2px;
    }
  }

  &--big {
    position: absolute;
    width: 400px;
    height: 400px;
    border-radius: 50%;
    opacity: 0.8;

    background: #ffffff;

    top: -200px;
    left: -200px;
  }

  &__wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    pointer-events: none;

    mix-blend-mode: normal;

    z-index: -1;

    @media all and (-webkit-min-device-pixel-ratio:0) and (min-resolution: .001dpcm) {
      z-index: 100;
      mix-blend-mode: multiply;
    }

    @supports (-moz-appearance:none){
      z-index: -1;
      mix-blend-mode: normal;
    }

    @supports (-ms-ime-align:auto) {
      z-index: -1;
    }

    &--big {
      z-index: -1;
    }

    &--small {
      z-index: 4;
    }
  }

  &__image {
    position: absolute;
    left: -5vw;
    top: -70px;
    width: 80vw;
    height: 220px;

    
    @include mq(ipadP) {
      left: -80px;
      top: -160px;
      width: 440px;
      height: 326px;
    }

    @include mq(ds) {
      left: -110px;
      top: -230px;
      width: 620px;
      height: 460px;

    }

    z-index: 2;

    &__wrapper {
      position: absolute;
      z-index: 2;

      mix-blend-mode: multiply;
      opacity: 0.7;
    }

    &__picture {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      background-position: top center;
      background-size: cover;
    }
  }
}
</style>
